export const removeArrayDuplicates = (arr: any[]) => {
  return arr.filter((item: any,
      index: any) => arr.indexOf(item) === index);
}